import { lazy } from 'react';
import { LinkTo } from 'shared/constants/linkTo';

const AdminPage= lazy(() => import('_deziiign/main/pages/admin/AdminPage'));
const RoleAdminPage = lazy(() => import('_deziiign/hsedesign/pages/roleAdmin/RoleAdminPage'));

const adminRoutes = [
    { path: LinkTo.admin, exact: true, component: AdminPage },
    { path: '/roleAdmin', exact: true, isPrivate: true, component: RoleAdminPage },
]

export default adminRoutes;import { lazy } from 'react';
import { LinkTo } from 'shared/constants/linkTo';

const AdminPage= lazy(() => import('_deziiign/main/pages/admin/AdminPage'));
const RoleAdminPage = lazy(() => import('_deziiign/hsedesign/pages/roleAdmin/RoleAdminPage'));

const adminRoutes = [
    { path: LinkTo.admin, exact: true, component: AdminPage },
    { path: '/roleAdmin', exact: true, isPrivate: true, component: RoleAdminPage },
]

export default adminRoutes;